import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class featurePointsConfigView_template extends vnTemplate {

    public validationsList: validationsList_template;
    public filterYears = [];
    public filterDepartments: multipleSelector_template;
    public filterAssignees: multipleSelector_template;

    readonly filterQuarters = [
        {"id": "q1", "name": "Q1"},
        {"id": "q2", "name": "Q2"},
        {"id": "q3", "name": "Q3"},
        {"id": "q4", "name": "Q4"},
    ];

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title icon i-settings">Feature Points Configuration</h3>

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
            <div class="sub-header">
                <div class="list-header w-justify">
                    <div class="w-left">
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Years</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: yearSelected"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: filterYears">
                                        <input type="radio" data-bind="checked : $parent.yearSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onYearChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Quarters</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: quarterSelected"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: filterQuarters">
                                        <input type="radio" data-bind="checked : $parent.quarterSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onQuarterChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ` + this.filterDepartments.getHtmlBuild() + `
                        ` + this.filterAssignees.getHtmlBuild() + `
                        ` + this.validationsList.getHtmlBuild()  + `
                    </div>
                </div>
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-departments"></div>
                    <div id="selected-assignees"></div>
                </div>
            </div>
            <div  class="w-list-results" id="list-results"  data-bind="" style="position: relative">
                <table class="list-results">
                    <thead>
                        <input data-bind="" type="hidden">
                        <input data-bind="" type="hidden">
                        <tr>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Id</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'departmentName') }, css: { 'list-sort-desc': orderByAndDirection()=='departmentName_DESC', 'list-sort-asc': orderByAndDirection()=='departmentName_ASC' }">Department</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'featurePointMultiplier') }, css: { 'list-sort-desc': orderByAndDirection()=='featurePointMultiplier_DESC', 'list-sort-asc': orderByAndDirection()=='featurePointMultiplier_ASC' }">Multiplier</span></th>
                            <th><span data-bind="" class="">Days Off</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'workStartDate') }, css: { 'list-sort-desc': orderByAndDirection()=='workStartDate_DESC', 'list-sort-asc': orderByAndDirection()=='workStartDate_ASC' }">Work Start Date</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'workEndDate') }, css: { 'list-sort-desc': orderByAndDirection()=='workEndDate_DESC', 'list-sort-asc': orderByAndDirection()=='workEndDate_ASC' }">Work End Date</span></th>
                            <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'isExcludedFromReport') }, css: { 'list-sort-desc': orderByAndDirection()=='isExcludedFromReport_DESC', 'list-sort-asc': orderByAndDirection()=='isExcludedFromReport_ASC' }">Report Inclusion</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: assignees">
                         <tr>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_id"><span data-bind="text: id"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_name"><span data-bind="text: name"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_department"><span data-bind="text: departmentName"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_feature_point_multiplier"><span data-bind="text: featurePointMultiplier"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_days_off"><span data-bind="text: daysOff"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_start_work_date"><span data-bind="text: workStartDate"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_end_work_date"><span data-bind="text: workEndDate"></span></td>
                            <td data-bind="click: $parent.onClickAssignee" class="cursor assignee_is_excluded_from_report"><span data-bind="text: isExcludedFromReport==0 ? 'Included' : 'Excluded'"></span></td>
                        </tr>                 
                    <tbody>
                    <tfoot>
                    </tfoot>
                </table>    
            </div>  
            <div class="w-form-body">
                
            </div>
            <div class="form-footer">
                <!--<button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>-->
            </div>
        `;
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        let viewModel = {
            orderBy: ko.observable("name")
            , orderByDirection: ko.observable("ASC")
            , orderByAndDirection: ko.observable("name_ASC")
            ,filterQuarters: ko.observableArray([])
            ,quarterSelected: ko.observable(this.getCurrentQuarter())
            ,filterYears: ko.observableArray([])
            ,yearSelected: ko.observable()
            ,assignees: ko.observableArray([])
            ,onClickAssignee: function(data){ huit_neuf_this.onClickAssignee(data.id); }
            ,onClickHolidays: function(data){ huit_neuf_this.onClickHolidays(); }
            ,onClickCancel: function(){ huit_neuf_this.onClickCancel(); }
            ,onQuarterChange: function () { huit_neuf_this.onQuarterChange();}
            ,onYearChange: function () { huit_neuf_this.onYearChange();}
            , onClickReorder: function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
            ,isTableLoading: ko.observable(0)
        }

        return viewModel;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.filterDepartments = new multipleSelector_template("filterDepartments", this.getTemplateViewModel(), this.caller);
        this.filterDepartments.setTagContainerId('selected-departments');
        this.filterDepartments.setTagContainerCaption('Selected Departments:');

        this.filterAssignees = new multipleSelector_template("filterAssignees", this.getTemplateViewModel(), this.caller);
        this.filterAssignees.setTagContainerId('selected-assignees');
        this.filterAssignees.setTagContainerCaption('Selected Assignees:');
    }

    protected getTemplateName(): string {
        return "featurePointsConfigView_template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form", "w-form-large", "w-form-larger", "margin-top"];
    }

    public getViewModelForRequest() {
        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            year: this.getTemplateViewModel().yearSelected,
            quarter: this.getTemplateViewModel().quarterSelected,
            departments: this.getTemplateViewModel().filterDepartments.selectedItems(),
            assignees: this.getTemplateViewModel().filterAssignees.selectedItems(),
        }
    }

    public setQuartersItems() {
        this.getTemplateViewModel().filterQuarters(this.filterQuarters);
    }

    public setYearsItems(years) {
        this.getTemplateViewModel().filterYears(years);
        this.getTemplateViewModel().yearSelected(years[0].id);
    }

    public setAssignees(assignees): void {
        this.getTemplateViewModel().assignees(assignees);
    }

    public setDepartmentsFilterItems(departments){

        this.filterDepartments.setItems(departments);
        this.filterDepartments.setLabel('Departments');
    }

    public setAssigneesFilterItems(assignees){

        this.filterAssignees.setItems(assignees);
        this.filterAssignees.setLabel('Assignees');
    }

    public setDefaultDepartmentsSelected(){

        // By default, we want everything to be selected
        let ids = [];
        let selectedItems = [];
        this.filterDepartments.getItems().forEach((item) => {

            ids.push(item.id);
            selectedItems.push(item);
        });
        this.filterDepartments.setSelectedItems(selectedItems);
        this.filterDepartments.setTags(ids, this.filterDepartments.getItems());
    }

    public getCurrentQuarter(){

        let today = new Date();
        let mm = today.getMonth() + 1;

        if (mm >= 1 && mm <= 3){

            return 'q1';
        }else if(mm >= 4 && mm <= 6){

            return 'q2';
        }else if(mm >= 7 && mm <= 9){

            return 'q3';
        }else{

            return 'q4';
        }
    }

    private onQuarterChange(){
        this.caller.getListData();
    }

    private onYearChange(){
        this.caller.getListData();
    }

    public onClickAssignee(id): void {
        this.caller.editAssignee(id,this.getTemplateViewModel().yearSelected(),this.getTemplateViewModel().quarterSelected());
    }

    public onClickHolidays(): void {
        this.caller.editHolidays(this.getTemplateViewModel().yearSelected(),this.getTemplateViewModel().quarterSelected());
    }

    private onClickCancel(){
        this.caller.cancelConfig();
    }

    public onClickReorder(value, data, event){

        if(typeof data.orderBy === 'undefined'){

            data = this.getTemplateViewModel();
        }

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if(data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){

            if( data.orderByDirection() == "DESC" ){

                data.orderByDirection("ASC");
            }
            else{

                data.orderByDirection("DESC");
            }
        }
        else{

            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/featurePointsConfigView_template.ts